import { RootState } from "../rootReducer"; // apne path ke hisab se update karo
import { WalletTransaction } from "./walletTypes";

export const selectWalletState = (state: RootState) => state.wallet;

export const selectWalletInfo = (state: RootState) => state.wallet.info;

export const selectWalletBalance = (state: RootState) =>
  state.wallet.info?.activeBalance ?? 0;

export const selectWalletLoading = (state: RootState) => state.wallet.loading;

export const selectWalletError = (state: RootState) => state.wallet.error;

export const selectWalletTransactions = (state: RootState) =>
  state.wallet.transactions;

// ---- Grouping helpers ----

export interface WalletTransactionMonthGroup {
  monthKey: string; // e.g. "2024-01"
  monthLabel: string; // "JANUARY 2024"
  items: WalletTransaction[];
}

const formatMonthLabel = (
  iso: string,
): {
  monthKey: string;
  label: string;
} => {
  const d = new Date(iso);
  const year = d.getFullYear();
  const month = d.getMonth(); // 0-11
  const monthNames = [
    "JANUARY",
    "FEBRUARY",
    "MARCH",
    "APRIL",
    "MAY",
    "JUNE",
    "JULY",
    "AUGUST",
    "SEPTEMBER",
    "OCTOBER",
    "NOVEMBER",
    "DECEMBER",
  ];

  const monthKey = `${year}-${String(month + 1).padStart(2, "0")}`;
  const label = `${monthNames[month]} ${year}`;
  return { monthKey, label };
};

export const groupTransactionsByMonth = (
  items: WalletTransaction[],
): WalletTransactionMonthGroup[] => {
  const groups = new Map<string, WalletTransactionMonthGroup>();

  items.forEach((tx) => {
    if (!tx.createdAt) return;

    const { monthKey, label } = formatMonthLabel(tx.createdAt);
    if (!groups.has(monthKey)) {
      groups.set(monthKey, {
        monthKey,
        monthLabel: label,
        items: [],
      });
    }

    groups.get(monthKey)!.items.push(tx);
  });

  // newest month first
  return Array.from(groups.values()).sort((a, b) =>
    a.monthKey < b.monthKey ? 1 : -1,
  );
};
